import { Component, OnInit } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { InventoryService } from '../../services/inventory.service';
import { DetailsService } from '../../services/details.service';
import { IInventoryType, IInventoryMasterDetail, IViewMasterDetailWithImage} from '../../interfaces/';
import { InventoryMasterDetail, ViewMasterDetailWithImage } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgxPicaService } from 'ngx-pica';

import { DomSanitizer } from '@angular/platform-browser';

// Editable Table concept
// https://mdbootstrap.com/docs/angular/tables/editable/

enum detailTypeEnums {
	feeding = 1,
	defecation = 2,
	shed = 3,
	growth = 4,
	health = 5,
	genetic = 6,
	additionalNote = 7
}

@Component({
  selector: 'add-multiple-inventory',
  templateUrl: './add-multiple-inventory.component.html',
  styleUrls: ['./add-multiple-inventory.component.css']
})
export class AddMultipleInventoryComponent implements OnInit {

	public genders: any[] = [];
  inventoryTypes: IInventoryType[] = [];
  masterDetailRecords: IInventoryMasterDetail[] = [];
  masterMaleRecords: IInventoryMasterDetail[] = [];
  masterFemaleRecords: IInventoryMasterDetail[] = [];
  
  saveSuccess: boolean;
  isAuthenticated: boolean = false;
  message = "";
  groupId: number = 0;
  
  newInventoryList: IInventoryMasterDetail[] = [];

  editField: string;
  
  constructor(private inventoryService: InventoryService, private router: Router, private detailsService: DetailsService,
    private _sanitizer: DomSanitizer, private _resizer: NgxPicaService) { }

  ngOnInit() {
    
    if(sessionStorage.getItem("token")){
        let obj = JSON.parse(sessionStorage.getItem("token"));
        if(obj && obj.Token != ""){
          this.isAuthenticated = true;
        }
      }
    else {
      this.router.navigate(['/login']);
    }
    this.message = "";

    if(sessionStorage.getItem("groupId")){
      let group = JSON.parse(sessionStorage.getItem("groupId"));
      if(group && group.GroupId != 0){
          this.groupId = group.GroupId;
      }
    }

    if(this.newInventoryList.length <= 0)
    {
      let item = new InventoryMasterDetail();
      item.InventoryTypeId = 0;
      item.DameId = 0;
      item.SireId = 0;
      item.Sex = 'Unsexed';
      item.GroupId = this.groupId;
      this.newInventoryList.push(item);
    }
    this.loadInventoryTypes();    
    this.loadMasterDetailRecords();
    this.loadGenderList();
  }

  eventlog()
  {
    //console.log(this.selectedDetailType);
  }

  loadInventoryTypes(){
    this.inventoryTypes = [];
    this.inventoryService.getInventoryTypes().subscribe(
      resp => {
      this.inventoryTypes = resp;
    });
  }

  loadMasterDetailRecords(){
    this.masterDetailRecords = [];
    
    this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
      resp => {
      this.masterDetailRecords = resp;
      this.masterDetailRecords.forEach(detail => {
        if(detail.Sex.toLowerCase() == "male"){
          this.masterMaleRecords.push(detail);
        }
        if(detail.Sex.toLowerCase() == "female"){
          this.masterFemaleRecords.push(detail);
        }
      });
    });
  }

  loadGenderList(){
    this.genders = [
        {id:1, desc:'Unsexed'},
        {id:2, desc:'Male'}, 
        {id:3, desc:'Female'}        
    ];
  }

  updateList(id: number, property: string, event: any) {
    let item = this.newInventoryList.find(item => { return item.Id == id});
    this.newInventoryList[id][property] = '';
    this.editField = event.target.textContent;
    this.newInventoryList[id][property] = this.editField;
    this.editField = '';
  }

  remove(id: any) {
    this.newInventoryList.splice(id, 1);
  }

  add() {
    let item = new InventoryMasterDetail();
    item.InventoryTypeId = 0;
    item.DameId = 0;
    item.SireId = 0;
    item.Sex = 'Unsexed';
    item.GroupId = this.groupId;
    this.newInventoryList.push(item);
  }

  changeValue(id: number, property: string, event: any) {
    this.newInventoryList[id][property] = '';
    this.editField = event.target.textContent;
  }

  resetForm(){
    this.newInventoryList = [];
  }

  createAllItems()
  {
    let RemainingCount = this.newInventoryList.length;
    this.message = 'Creating ' + RemainingCount + '. Please wait.';
    this.newInventoryList.forEach(i => {
      if(i.SireId == 0){
        i.Sire = "Unknown";
      }
      else {
        let Sire = this.masterMaleRecords.find(detail => { return detail.Id == i.SireId});
        if(Sire){
          if(Sire.AnimalName && Sire.AnimalName != '' && Sire.Id){
            i.Sire = Sire.AnimalName +"/"+ Sire.AnimalID;
          }
          else if((!Sire.AnimalName || Sire.AnimalName == '') && Sire.Id)
          {
            i.Sire = Sire.AnimalID;
          }
          else if(Sire.AnimalName && Sire.AnimalName != '' && !Sire.Id)
          {
            i.Sire = Sire.AnimalName;
          }
        }
      }
      if(i.DameId == 0){
        i.Dame = "Unknown";
      }
      else {
        let Dame = this.masterFemaleRecords.find(detail => { return detail.Id == i.DameId});
        if(Dame){
          if(Dame.AnimalName && Dame.AnimalName != '' && Dame.Id){
            i.Dame = Dame.AnimalName +"/"+ Dame.AnimalID;
          }
          else if((!Dame.AnimalName || Dame.AnimalName == '') && Dame.Id)
          {
            i.Dame = Dame.AnimalID;
          }
          else if(Dame.AnimalName && Dame.AnimalName != '' && !Dame.Id)
          {
            i.Dame = Dame.AnimalName;
          }          
        }      
      }
      let masterToSubmit = new ViewMasterDetailWithImage();
      masterToSubmit.masterDetail = i;
      this.detailsService.createMasterDetailRecord(masterToSubmit).subscribe(
        resp => {
          this.saveSuccess = true;
          RemainingCount = RemainingCount - 1;
          if(RemainingCount == 0){
            this.message = 'All Records have been created.';
          }
          else{
            this.message = 'Creating ' + RemainingCount + '. Please wait.';  
          }          
      });
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/add-multiple-inventory/add-multiple-inventory.component.ts